/**
 * @Description 区域保护-机会点模块
 */
import { FC, useState } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import styles from '../index.module.less';
import IconFont from '@/common/components/IconFont';
import AreaProtectionDrawer from '../../../AreaProtection/detail';
const AreaProtect:FC<any> = ({
  detail
}) => {
  const { protectInfo } = detail || {};
  const [open, setOpen] = useState<boolean>(false);

  return <div className='mt-10'>
    <V2Title divider type='H2' text='区域保护'/>
    <div className={styles.areaProtectCon}
      onClick={() => {
        setOpen(true);
      }}>
      <div className={styles.card}>
        <span className={styles.content}>{protectInfo?.scopeProtection || '-'}</span>
        <span className={styles.label}>区域保护范围</span>
      </div>
      <div className={styles.card}>
        <span className={styles.content}>{protectInfo?.daysToExpiration || '-'}</span>
        <span className={styles.label}>距离到期时间</span>
      </div>
      <div className={styles.card}>
        <span className={styles.content}
          style={{
            color: protectInfo?.statusName === '申请中' ? '#006AFF' : '#FF861D'
          }}
        >{protectInfo?.statusName || '-'}
          <IconFont iconHref='iconic_next_black_seven' className='fs-10 ml-2'/>
        </span>
        <span className={styles.label}>保护状态</span>
      </div>
    </div>
    <AreaProtectionDrawer
      id={detail.id}
      open={open}
      setOpen={setOpen}
      approvalId={protectInfo?.approvalId}
    />
  </div>;
};
export default AreaProtect;
